export const environment = {
  production: false,
  STATIC_MAPS_API_KEY: 'AIzaSyDDS1X-dRisFBSVDHzEfCjX1JQ_pv5Qd8k',
  DYNAMIC_MAPS_API_KEY: 'AIzaSyApQvqm1t9GlZ1PVf9WIpqM7rrtl0z15rE',
  PORT: 199
};
